export default {
    namespaced: true,

    state: {
        currentDataId: null,
        availableDatas: null
    },

    mutations: {
        setCurrentDataId(state, data) {
            state.currentDataId = data;
        },
        setAvailableDatas(state, datas) {
            state.availableDatas = datas;
        }
    },

    getters: {
        getCurrentDataId: ((state) => {
            return state.currentDataId;
        }),
        getAvailableDatas: ((state) => {
            return state.availableDatas;
        }),
    }
};